// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"362aa4dc71fe31b4dfdf","873":"767e07c9955a08535ce9"}[chunkId] + ".js";
};